import type { Service } from '../types/portfolio';

// The three services from konradwalz.com/leistungen, condensed.
export const services: Service[] = [
  {
    id: 'sheet-metal',
    title: 'Blech- & Schweißkonstruktionen',
    summary: 'Gehäuse und Verkleidungen, fertigungsgerecht ausgelegt.',
    points: ['Kantfertige DXF-Abwicklungen', 'Biegeradien, k-Faktor & Freischnitte', 'Schweißbaugruppen nach DIN EN ISO 5817'],
    icon: 'chamfer',
  },
  {
    id: 'cnc',
    title: 'Zerspanungs- & CNC-Frästeile',
    summary: 'Volumenmodelle optimiert für weniger Rüstzeit.',
    points: ['3- und 5-Achs-Bearbeitung', 'Form- & Lagetoleranzen nach DIN EN ISO 1101', 'Passungen nach DIN ISO 286'],
    icon: 'octagon',
  },
  {
    id: 'reverse',
    title: 'Reverse Engineering & Digitalisierung',
    summary: 'Aus Fotos, Scans oder alten Zeichnungen zum neuen Modell.',
    points: ['Parametrischer Neuaufbau', 'Automatische Stücklisten (BOM)', 'Kollisionsanalysen'],
    icon: 'hexagon',
  },
];
